// Global packages and components
import { Heading, Trustpilot, InlineLink } from '~/components'
import { ProductStringAttribute } from '~/types'

interface Props {
  title: string
  shortDescription?: ProductStringAttribute
  stockCode?: string
  video?: boolean
  requiresFraudCheck?: boolean
}

// Main export
const ProductHeader = ({
  title,
  shortDescription,
  stockCode,
  video,
}: Props) => (
  <>
    <Heading
      tag="h1"
      size="h3"
    >
      {title}
    </Heading>
    {stockCode && (
      <div className="relative z-[9] mb-6 flex items-start gap-2">
        <Trustpilot
          templateId="product-mini"
          product={{ sku: stockCode, name: title }}
        />
        <InlineLink
          to="#product-reviews"
          label="Read reviews"
          size="xs"
        />
      </div>
    )}
    {shortDescription?.value && (
      <div className="mb-6">
        <p dangerouslySetInnerHTML={{ __html: shortDescription.value }} />
        {video && (
          <div className="inline-block">
            <InlineLink
              to="#product-video"
              label="Watch Video"
              size="sm"
              icon="videoCameraIcon"
            />
          </div>
        )}
      </div>
    )}
  </>
)

export default ProductHeader
